const html = require("./html/availableQuoteView.html");
import {setElementsFromScope, insertValAndManageFocus, toggleClassViaBool, show, hide, handleDisplayFor, insertTextAndClean, setRadioState, enableInput, disableInput, setRequired, setUniqNames, setDisabled} from "../../../utilities/selectorHelpers";
import {toCurrency} from "../../../utilities/currency";
import {toWeekDayMonthAndDay} from "../../../utilities/general";
import _ from "underscore";
import $ from "jquery";
import AsnStore from "../../../stores/AsnStore";


const elementsMap = {
  quoteRadio: ".quote-radio",
  estimatedPickupDate: ".estimated-pickup-date",
  estimatedTransitTime: ".estimated-transit-time",
  estimatedCost: ".estimated-cost"
};

export default function AvailableQuoteView(compositeQuoteId, 
  {
    getSelectedQuote,
    onAsnFieldsChange,
    getAsn
  }){

  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    render();
  };

  function bindElements(){
    els.quoteRadio.on("click", onQuoteRadioClick);
  }


  function onQuoteRadioClick(e){
    const attrs = _(getQuote()).pick("quoteId", "optionId");
    // console.log(attrs);
    onAsnFieldsChange(attrs);
  }



  function bindStores(){
    AsnStore.bindListener(`asns:change:${getAsnId()}`, updateSelf);
  }

  self.unbindListeners = function(){
    AsnStore.unbindListener(`asns:change:${getAsnId()}`, updateSelf);
  };

  function setWidgets(){

  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  self.getElement = function(){
    return self._element;
  }


  function update(){
    // handle rendering children
    updateSelf();
  }

  function updateSelf(){
    // handle updating values;
    updateClasses();
    updateValues();
    updateText();
  }

  function updateClasses(){
    toggleClassViaBool(self.getElement(), "divider-group-selected", isSelectedQuote());
  }


  function updateValues(){
    setRadioState(els.quoteRadio, isSelectedQuote());
  }

  function updateText(){
    const quote = getQuote();
    if(!!quote){
      insertTextAndClean(els.estimatedPickupDate, toWeekDayMonthAndDay(quote.estimatedPickupDate));
      insertTextAndClean(els.estimatedTransitTime, quote.estimatedTransitTime);
      insertTextAndClean(els.estimatedCost, toCurrency(quote.estimatedCost));
    }
  }

  function getAsnId(){
    return getAsn().id;
  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    bindElements();
    bindStores();
    update();
  }

  function isSelectedQuote(){
    return _.isEqual(getSelectedQuote(), getQuote());
  }

  function getQuote(){
    return QuoteStore.getDataViaId(compositeQuoteId);
  }
}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/AvailableQuoteView.js